import { render } from "./AvaliacaoFuncional.vue?vue&type=template&id=3807a2b1&scoped=true"
import script from "./AvaliacaoFuncional.vue?vue&type=script&lang=js"
export * from "./AvaliacaoFuncional.vue?vue&type=script&lang=js"

import "./AvaliacaoFuncional.vue?vue&type=style&index=0&id=3807a2b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3807a2b1"]])

export default __exports__